import type { Vehicle } from '../types';

export const defaultVehicle: Vehicle = {
  id: 'mh01ab1234',
  number: 'MH 01 AB 1234',
  label: 'Private Car',
  totalPendingChallans: 3,
  totalAmountDue: 1850,
};

export const vehicles: Vehicle[] = [
  defaultVehicle,
  {
    id: 'dl04cd5678',
    number: 'DL 04 CD 5678',
    label: 'Private Car',
    totalPendingChallans: 6,
    totalAmountDue: 4700,
  },
  {
    id: 'hr26ef9012',
    number: 'HR 26 EF 9012',
    label: 'Commercial Vehicle',
    totalPendingChallans: 1,
    totalAmountDue: 500,
  },
];
